/**
 * Created by wushaoyong on 2017/4/18.
 */
export const TEXT_TYPE = 'TEXT'
export const IMAGE_TYPE = 'IMAGE'
export const WORK_ORDER_TYPE = 'WORK_ORDER'
export const FILE_TYPE = 'FILE'
export const EVENT_TYPE = 'EVENT'
export const VIDEO_TYPE = 'VIDEO'



// WEBPACK FOOTER //
// ./src/common/Constants.js